import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import CountUp from 'react-countup';
import styles from './map-fact.module.scss';
import posed from 'react-pose';
import { useMatchMedia } from '../../hooks/use-match-media';

const Fact = posed.div({
  visible: {
    scale: 1,
  },
  hidden: {
    scale: 0,
  },
});

export interface MapFactProps {
  aboveValue?: string;
  value?: number;
  belowValue?: string;
  visible?: boolean;
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

export const MapFact: React.FC<MapFactProps> = ({ position, visible, aboveValue, belowValue, value, children }) => {
  let positionClass;

  switch (position) {
    case 'top-left':
      positionClass = 'map-grid-top-left';
      break;
    case 'top-right':
      positionClass = 'map-grid-top-right';
      break;
    case 'bottom-left':
      positionClass = 'map-grid-bottom-left';
      break;
    case 'bottom-right':
      positionClass = 'map-grid-bottom-right';
      break;
    default:
      positionClass = 'map-grid-top-left';
      break;
  }

  const [targetEl, setTargetEl] = useState<Element | null>(null);

  useEffect(() => {
    const el = document.querySelector('#overlayGrid');
    setTargetEl(el);
  }, []);

  const isDesktop = useMatchMedia(`(min-width: ${styles.medium})`);

  const factContent = (
    <>
      {aboveValue && <span className={styles.text}>{aboveValue}</span>}
      {value && (
        <span className={styles.value}>
          <CountUp delay={0.1} end={value} separator="," />
        </span>
      )}
      {belowValue && <span className={styles.text}>{belowValue}</span>}
      {children}
    </>
  );

  if (targetEl && isDesktop) {
    return ReactDOM.createPortal(
      <Fact className={`${styles.fact} ${positionClass}`} pose={visible ? 'visible' : 'hidden'}>
        {factContent}
      </Fact>,
      targetEl
    );
  }
  return (
    <Fact className={`${styles.fact} ${styles.factSmall}`} pose={visible ? 'visible' : 'hidden'}>
      {factContent}
    </Fact>
  );
};

MapFact.defaultProps = {
  position: 'top-left',
};
